var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "star-rating"
  }, [_vm._l((_vm.maxStars), function(index) {
    return _c('span', {
      key: index,
      staticClass: "star",
      class: {
        'half': _vm.allowHalfStars && _vm.isHalfStar(index),
        'full': _vm.isFullStar(index)
      },
      style: ({
        fontSize: _vm.starSize + 'px'
      }),
      on: {
        "click": function($event) {
          _vm.setRating(index, $event)
        },
        "mousemove": function($event) {
          _vm.setHoverRating(index, $event)
        },
        "mouseleave": _vm.resetHoverRating
      }
    }, [_vm._v("\n    ★\n  ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "rating-value"
  }, [_vm._v(_vm._s(_vm.rating))])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-279e679d","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/StarRating/StarRating.vue
// module id = 1074
// module chunks = 0